import { Checkbox } from '@mui/material';
import { forwardRef } from 'react';

import { FormFieldControl } from './FormFieldControl';

import type { FormFieldControlProps } from './FormFieldControl';
import type { CheckboxProps } from '@mui/material';
import type { FC } from 'react';

export type CheckboxFieldProps = Omit<FormFieldControlProps, 'children'> & CheckboxProps;

export const CheckboxField: FC<CheckboxFieldProps> = forwardRef<
  HTMLButtonElement,
  CheckboxFieldProps
>( function CheckboxField({
  classes,
  required,
  disabled,
  sx,
  className,
  style,
  color,
  icon,
  size,
  id,
  checkedIcon,
  disableRipple,
  indeterminate,
  indeterminateIcon,
  inputRef,
  inputProps,
  value,
  onChange,
  checked,
  /* FormFieldControlProps*/
  ...props
}, ref) {
  return (
    <FormFieldControl
      color={color}
      required={required}
      size={size}
      disabled={disabled}
      checked={checked}
      value={value}
      inputRef={inputRef}
      onChange={onChange}
      {...props}
    >
      <Checkbox
        classes={classes}
        required={required}
        disabled={disabled}
        sx={sx}
        className={className}
        ref={ref}
        style={style}
        color={color}
        icon={icon}
        size={size}
        id={id}
        checkedIcon={checkedIcon}
        disableRipple={disableRipple}
        indeterminate={indeterminate}
        indeterminateIcon={indeterminateIcon}
        inputRef={inputRef}
        inputProps={inputProps}
        value={value}
        /* use onChange on Checkbox ? */
        // onChange={onChange}
        checked={checked}
      />
    </FormFieldControl>
  );
} );
